/**
 * Anchors of the Setup sections that other screens link to (`/new-client-offer/setup#…`). Kept apart from the
 * section components so pure helpers elsewhere (the Hayven Tap preview) can point here without importing UI.
 */

/** 1 · The gift: the offer page drawer's "Edit them in The gift" link brings it into view. */
export const OFFER_DISCOUNT_ANCHOR = 'offer-discount';

/** 2 · Who gets it: the first-time walk-ins switch (Settings › Check-in and Hayven Tap point here). */
export const OFFER_WHO_GETS_IT_ANCHOR = 'offer-who-gets-it';

/** 3 · Where they get it: the go-live dialog's "use it in the salon only" link opens Setup here. */
export const OFFER_PLACEMENTS_ANCHOR = 'offer-placements';

/**
 * The ad page's Customize drawer: Marketing › Campaigns' pinned offer page row links here (pencil, "Customize page"),
 * and Setup opens the drawer once on arrival. Not a section id: the hash is cleared after it opens.
 */
export const OFFER_PAGE_CUSTOMIZE_ANCHOR = 'customize-page';

/**
 * Friends of your clients: the friends card on Setup (inside 3 · Where they get it) and the friends results on
 * Overview share this id, so old Refer a Friend links land on the matching part.
 */
export const OFFER_FRIENDS_ANCHOR = 'friends';
